module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAWlBMVEUAAAAAAADt7e3j4+MAAAAAAAAAAAAAAAALCwtHcEz+/v6NjY34+PjMzMz7+/vc3Nzp6en8/PzCwsL////////Y2Njm5ub9/f339/f39/fV1dX8/Pyqqqr////6dUAEAAAAHXRSTlMPBZVHFgIKExkA7SqdIdFgYsVH9PpDfuJ4rVy1DPeWWgsAAACUSURBVBjTRc1ZEgMhCEVRVBSj9jxmePvfZsTuSu4fp0DJe3/263qUzvtHjfxnQmtxRolMnYvbzgXoVGgERqp1CW9ThSY8SbRRV4ynhEGEmSUCLtzA2gVGT9rMA5BDMProoHNOKKQgPWDneU/AS0gh97hLcwPhvdJhbaUtBFLhnGOMKq6BcGw1odBWfrLWn/47bJfyBfQbDHrs38d7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ptgames/ptsearch.png
// module id = GI4U
// module chunks = 3